export async function shareApi(settings, config) {
    let shareTrigger = document.querySelector('.js-btn-share');

    if (shareTrigger) {
        const { initWebShare } = await import(/* webpackMode: "lazy" */ './inc/web-share.async');

        initWebShare(shareTrigger, settings, config);
    }
}
